import React from "react";

import { Instant } from "@js-joda/core";
import { useTimezone } from "hooks/useTimezone";
import { Tooltip } from "primereact/tooltip";
import { DATE_FORMATTER_SECONDS } from "utils/constants";
import { BROWSER_ZONE_ID, fmtDatetimeAdvanced } from "utils/time-utils";

export default function CompanyClock() {
  const tz = useTimezone();

  const [now, setNow] = React.useState(Instant.now());

  React.useEffect(() => {
    const interval = setInterval(() => {
      setNow(Instant.now());
    }, 1000);
    return () => clearInterval(interval);
  });

  const companyTime = fmtDatetimeAdvanced(now, tz.company, {
    showOffset: true,
    pattern: DATE_FORMATTER_SECONDS,
  });

  return (
    <span>
      <span id="company-clock">{companyTime}</span>

      <Tooltip position="bottom" target="#company-clock" style={{ zIndex: 99999 }}>
        <ClockTooltipContent now={now} companyTime={companyTime} />
      </Tooltip>
    </span>
  );
}

type ClockTooltipContentProps = { now: Instant; companyTime: string };

const ClockTooltipContent: React.FC<ClockTooltipContentProps> = ({
  now,
  companyTime,
}: ClockTooltipContentProps) => {
  const tz = useTimezone();
  const displayTime = fmtDatetimeAdvanced(now, tz.display, {
    showOffset: true,
    pattern: DATE_FORMATTER_SECONDS,
  });
  const browserTime = fmtDatetimeAdvanced(now, BROWSER_ZONE_ID, {
    showOffset: true,
    pattern: DATE_FORMATTER_SECONDS,
  });

  return (
    <div className="flex flex-column line-height-1">
      <p className="mb-1">
        Display timezone: <b>{tz.display.toString()}</b>
      </p>
      <p className="mb-1">
        Company timezone: <b>{tz.company.toString()}</b>
      </p>
      <p className="mb-1">
        Computer timezone: <b>{BROWSER_ZONE_ID.toString()}</b>
      </p>
      <p className="mb-1">
        Display time: <b>{displayTime}</b>
      </p>
      <p className="mb-1">
        Company time: <b>{companyTime}</b>
      </p>
      <p className="mb-1">
        Browser time: <b>{browserTime}</b>
      </p>
    </div>
  );
};
